import type {
  DeliveryResponse,
  PlanDeliveryState,
} from "@/forwards2/forwardsTypes";

/**
 * One delivery exactly as the deal holds it, in the plan save's terms: its window, its price, and
 * one planned volume per exact production period its slices carry (backed plus open), in slice
 * order. A quarter and a month inside it are different periods and stay separate entries.
 */
export const deliveryStateOf = (
  delivery: DeliveryResponse
): PlanDeliveryState => {
  const planned = new Map<string, { period: string; planned_mwh: number }>();
  for (const slice of delivery.slices) {
    const key = `${slice.period_start}/${slice.period_end}`;
    const entry = planned.get(key) ?? {
      period: slice.period_label,
      planned_mwh: 0,
    };
    entry.planned_mwh += slice.volume_mwh;
    planned.set(key, entry);
  }
  return {
    id: delivery.id,
    delivery_window_start: delivery.delivery_window_start,
    delivery_window_end: delivery.delivery_window_end,
    unit_price: delivery.unit_price,
    periods: [...planned.values()],
  };
};
